import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_GEN_AI_DEMO_IEAM_3 = {
  title: `Tony's clear warehouse management \nrequest is passed through the Intent API. \nThis powerful component deciphers his \nwords, <span style="color: #BEE3FF;"> extracting the essence of his \nneeds.</span> It transforms Tony's prompts into \n actionable insights.`,
  subtitle: "ai ASSISTED demo",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_119"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_117"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_GEN_AI_Demo_01.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/IEAM/IEAM_GEN_AI_DEMO_03_BUBBLE.png",
          imageStyle: { marginLeft: "132.5px", marginTop: "54px" },
        },
        {
          image: "ENG/IEAM/IEAM_GEN_AI_DEMO_03_SCHEME.png",
          imageStyle: {
            marginTop: "-5px",
            marginLeft: "51px",
          },
        },
      ]}
      pageNumber={"ENG_118"}
    />
  ),
};
